(() => {

    const studentProfileModal = $uibModal => {

        const openModal = () => {
            const modalInstance = $uibModal.open({
                templateUrl: 'studentProfileModal.html',
                controller: 'studentProfileModalCtrl',
                size: 'l'
            });

            modalInstance.result.then(() => {}, () => {});
        }

        const dir = {
            restrict: 'A',
            link: (scope, elm) => {
                elm[0].addEventListener('click', () => openModal());
            }
        };

        return dir;
    }

    angular.module('Uscapp').directive('studentProfileModal', ['$uibModal', studentProfileModal]);

    const studentProfileModalCtrl = ($scope, $uibModalInstance) => {
        $scope.close = () => $uibModalInstance.dismiss();
    }

    angular.module('Uscapp').controller('studentProfileModalCtrl', ['$scope', '$uibModalInstance', studentProfileModalCtrl]);

})();